module.exports = __webpack_public_path__ + "media/upload_video.754a518c.mp4";